import React from 'react';
import { translate } from '../../i18n';

interface BusCardProps {
  flightName?: string;
  filledPercentage?: string;
  currentCount?: number;
  totalCount?: number;
  totalWeight?: string;
  filledWeight?: string;
  bgColor?: string;
  cancelled: boolean;
  pilotWeight:number;
}

const FlightCard: React.FC<BusCardProps> = ({
  flightName,
  filledPercentage,
  currentCount,
  totalCount,
  totalWeight,
  filledWeight,
  bgColor,
  cancelled,
  pilotWeight,
}) => {
  const newAllocatedPax = currentCount ? currentCount : 0;
  const newCapacity = totalCount ? totalCount : 0;
  const dynamicFilledPercentage = (
    (newAllocatedPax / newCapacity) *
    100
  ).toFixed(0);

  const newFilledWeight = filledWeight ? Number(filledWeight) : 0; 
  const newPilotWeight = pilotWeight ?? 0;

  const filledWeightWithPilotWeight = newFilledWeight + newPilotWeight;

  return (
    <div className={`rounded-lg shadow p-4  ${bgColor}`}>
      <h3 className="text-text-secondary mb-1 text-[14px] font-sora text-left">
        {flightName ? flightName : 'Zau Flight 1'}
      </h3>
      <div className="flex items-center space-x-2">
        <div className="w-full bg-[#C2F3D6] rounded-full h-2 relative">
          <div
            className={`${Number(dynamicFilledPercentage) < 101 ? 'bg-[#22AD5C]' : 'bg-red-500'}  h-2 rounded-full`}
            style={{
              width: `${Number(dynamicFilledPercentage) < 101 ? dynamicFilledPercentage : 100}%`,
            }}
          ></div>
        </div>
      </div>
      <p className="text-textColorGray text-sm mb-2 text-left">
        {dynamicFilledPercentage ? dynamicFilledPercentage : 0}% Filled
      </p>
      <div className="flex justify-between">
        <p className="text-textColorGray text-sm text-left">
          {translate('flightAllocation.card.pax')}
          <p className="font-bold">
            <span
              className={
                currentCount === undefined || isNaN(Number(currentCount))
                  ? 'text-text-primary'
                  : Number(currentCount) <= Number(totalCount)
                    ? 'text-text-textGreen'
                    : 'text-text-textRed'
              }
            >
              {currentCount}
            </span>
            <span className="font-normal text-sm text-textColor">
              /{totalCount}
            </span>
          </p>
        </p>
        <p className="text-textColorGray text-sm text-left">
          <p className="text-textColorGray">
            {translate('flightAllocation.card.weight')}
          </p>

          <p className="font-bold">
            <span
              className={
                filledWeightWithPilotWeight === undefined ||
                isNaN(Number(filledWeightWithPilotWeight))
                  ? 'text-text-primary'
                  : Number(filledWeightWithPilotWeight) < Number(totalWeight)
                    ? 'text-text-textGreen'
                    : 'text-text-textRed'
              }
            >
              {filledWeightWithPilotWeight.toFixed(1)}
            </span>
            <span className="font-normal text-sm text-textColor">
              /{totalWeight}
            </span>
          </p>
        </p>
      </div>
      {cancelled && (
        <div className="text-left flex">
          <span
            className={`w-[130px] h-[30px] px-3 py-1 rounded-full text-sm text-center font-medium bg-red-100 text-red-700`}
          >
            {translate('flightAllocation.card.cancelled')}
          </span>
        </div>
      )}
    </div>
  );
};

export default FlightCard;
